// Site-wide light/dark theme. Applies a `dark-theme` class to <html>, which
// every stylesheet keys off of via CSS variables (see :root / html.dark-theme
// in assets/css/common.css). Persisted through the same vuex-persistedstate
// plugin used by Cart/Wishlist/Course/Settings (see store/index.js), so a
// visitor's choice survives a refresh. The very first time a visitor arrives
// with nothing saved yet, it falls back to their OS/browser preference.

function systemPrefersDark() {
    return typeof window !== 'undefined'
        && !!window.matchMedia
        && window.matchMedia('(prefers-color-scheme: dark)').matches;
}

function applyThemeClass(theme) {
    if (typeof document === 'undefined') return;
    document.documentElement.classList.toggle('dark-theme', theme === 'dark');
}

const state = {
    theme: null, // 'light' | 'dark' | null (not decided/applied yet)
}
const mutations = {
    SET_THEME(state, theme) {
        state.theme = theme;
        applyThemeClass(theme);
    },
}
const actions = {
    // Called once on app boot. vuex-persistedstate has already rehydrated
    // `state.theme` from localStorage by this point if a choice was saved
    // previously, so this only needs to supply the system-preference fallback.
    initTheme({ state, commit }) {
        commit('SET_THEME', state.theme || (systemPrefersDark() ? 'dark' : 'light'));
    },
    toggleTheme({ state, commit }) {
        commit('SET_THEME', state.theme === 'dark' ? 'light' : 'dark');
    },
}
const getters = {
    theme: state => state.theme || 'light',
    isDarkTheme: state => state.theme === 'dark',
}
export default {
    state,
    mutations,
    actions,
    getters,
}
